<div fxLayout="row">
  <div fxLayout="column">
    <table role="presentation">
      <tr *ngIf="facReportObject.callHandlersName">
        <td class="field-label">Call Handler's Name:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.callHandlersName">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Anonymity Status:</td>
        <th class="fieldValue">{{ AnonymityStatus }}</th>
      </tr>
      <tr>
        <td class="field-label">Country:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.country">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Name of Organisation:</td>
        <th class="fieldValue">{{ facReportObject.organisation }}</th>
      </tr>
      <tr>
        <td class="field-label">Location/Address:</td>
        <th class="fieldValue">{{ facReportObject.location }}</th>
      </tr>
      <tr>
        <td class="field-label">Relationship With Organisation:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.relationship">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Reported Person:</td>
        <th class="fieldValue">{{ facReportObject.person }}</th>
      </tr>
      <tr>
        <td class="field-label">Job Role/Title:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation" [innerHtml]="facReportObject.role">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Department:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.department">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Start Date:</td>
        <th class="fieldValue">{{ facReportObject.startDate | dateFormat }}</th>
      </tr>
      <tr>
        <td class="field-label">Reported Before?:</td>
        <th class="fieldValue" *ngIf="facReportObject.reportedBefore == true">
          <span translate [language]="language" [showTranslation]="showTranslation">Yes</span>
        </th>
        <th class="fieldValue" *ngIf="facReportObject.reportedBefore == false">
          <span translate [language]="language" [showTranslation]="showTranslation">No</span>
        </th>
      </tr>
      <tr *ngIf="facReportObject?.reportedBefore == true">
        <td class="field-label">Reported Date:</td>
        <th class="fieldValue">
          {{ facReportObject.whenReportedDate | dateFormat }}
        </th>
      </tr>
      <tr *ngIf="facReportObject?.reportedBefore == true">
        <td class="field-label">Reported To:</td>
        <th class="fieldValue">{{ facReportObject.whoReportedTo }}</th>
      </tr>
      <tr *ngIf="facReportObject?.reportedBefore == true">
        <td class="field-label">What was the outcome?:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.whatWasTheOutcome">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">How did you become aware of the wrongdoing?:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.howAwareOfWrongDoing">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Details Reported:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.details">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Were there any witnesses?:</td>
        <th class="fieldValue" *ngIf="facReportObject.anyWitnesses == true">
          <span translate [language]="language" [showTranslation]="showTranslation">Yes</span>
        </th>
        <th class="fieldValue" *ngIf="facReportObject.anyWitnesses == false">
          <span translate [language]="language" [showTranslation]="showTranslation">No</span>
        </th>
      </tr>
      <tr *ngIf="facReportObject.anyWitnesses == true">
        <td class="field-label">Witness Details:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.furtherInformation">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">Preferred Resolution:</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.resolution">
          </span>
        </th>
      </tr>
      <tr *ngFor="let question of facReportObject.customQuestionResponses; let i = index">
        <td class="field-label">{{ facReportObject.customQuestionResponses[i]['label'] }}</td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.customQuestionResponses[i]['response']">
          </span>
        </th>
      </tr>
      <tr>
        <td class="field-label">
          How did you become aware of SeeHearSpeakUp?:
        </td>
        <th class="fieldValue">
          <span translate [language]="language" [showTranslation]="showTranslation"
            [innerHtml]="facReportObject.howAware">
          </span>
        </th>
      </tr>
    </table>
  </div>
</div>